"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTES = void 0;
var ROUTES = {
    HOME: "/",
    NOT_FOUND: "*",
    AUTH: "/auth",
    LOGIN: "/auth/login",
    VALIDATE_ACCOUNT: "/auth/validate",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
    ACCEPT_INVITATION: "/auth/accept-invitation/:token",
    LEGACY_LOGIN: "/login",
    ACCOUNT_SUSPENDED: "/account-suspended",
    TASKS_DASHBOARD: "/tasks-dashboard",
    TASK_VIEW: "/tasks-dashboard/:id",
    FACILITY_DASHBOARD: "/facility-dashboard",
    ALARMS: "/alarms",
    ALARM_VIEW: "/alarms/:id",
    NOTIFICATIONS: "/notifications",
    NOTIFICATION_VIEW: "/notifications/:id",
    FACILITY_MANAGEMENT: "/facility-management",
    FACILITY_VIEW: "/facility-management/:id",
    GROW_CYCLES: "/grow-cycles",
    GROW_CYCLE_VIEW: "/grow-cycles/:id",
    GROW_CYCLE_SOP_VIEW: "/grow-cycles/:id/sops/:sopId",
    DEVICES: "/devices",
    DEVICE_VIEW: "/devices/:id",
    STARTING_MATERIAL: "/starting-material",
    SEED_VIEW: "/starting-material/:id",
    MOTHER_ROOM: "/mother-room",
    MOTHER_PLANT_VIEW: "/mother-room/:id",
    CLONE_BATCH_VIEW: "/mother-room/clone-batches/:id",
    QUALITY_MANAGEMENT: "/quality-management",
    SOP_LIBRARY: "/quality-management/sop-library",
    SOP_LIBRARY_VIEW: "/quality-management/sop-library/:id",
    AREA_LIBRARIES: "/quality-management/area-libraries",
    USER_MANAGEMENT: "/user-management",
    USERS: "/user-management/users",
    USER_VIEW: "/user-management/users/:id",
    ADMINISTRATION: "/user-management/administration",
    CLIENTS: "/clients",
    CLIENT_LIST: "/clients/list",
    CLIENT_INVITATIONS: "/clients/invitations",
    CLIENT_VIEW: "/clients/:id",
    PROFILE: "/profile",
    ORGANIZATION: "/organization",
    SETTINGS: "/settings",
    BILLING_SETTINGS: "/settings/billing",
    PERMISSIONS_SETTINGS: "/settings/permissions",
    INTEGRATIONS: "/integrations",
    EWELINK_CALLBACK: "/integrations/ewelink/callback",
    PRIVACY_POLICY: "/privacy-policy",
    TERMS: "/terms",
};
exports.ROUTES = ROUTES;
